import { Logo1Dark, Logo1White } from '@blocksuite-local/icons/auto/24/rc';
import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;
  const LogoIcon = resolvedTheme === 'dark' ? Logo1White : Logo1Dark;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a href="/" rel="noreferrer" className={styles.affineLogo}>
            <LogoIcon width={32} height={32} />
          </a>

          <DesktopNavbar />
          <MobileNavbar />
        </div>
      )}

      {children}
    </div>
  );
};
